/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Create_Duplicate_OpenInputs */

const en_task_create_duplicate_open = /** @type {(inputs: Task_Create_Duplicate_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An open task of this type already exists for this case or client.`)
};

const pt_br2_task_create_duplicate_open = /** @type {(inputs: Task_Create_Duplicate_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe uma atividade aberta deste tipo para este caso ou cliente.`)
};

/**
* | output |
* | --- |
* | "An open task of this type already exists for this case or client." |
*
* @param {Task_Create_Duplicate_OpenInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_create_duplicate_open = /** @type {((inputs?: Task_Create_Duplicate_OpenInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Create_Duplicate_OpenInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_create_duplicate_open(inputs)
	return pt_br2_task_create_duplicate_open(inputs)
});